import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FileInfoType, fileUploadValidator, FileService, FileUploadOptions, SbeUploadEventTypes } from '@schoolbelle/api/file';
import { tap, finalize, last, filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-file-row',
  templateUrl: './file-row.component.html',
  styleUrls: ['./file-row.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class FileUploadListFileRowComponent implements OnInit {
  @Input('index') index:number;
  @Input() file:File|FileInfoType;
  @Input() options:FileUploadOptions;
  @Input() access_token:string;
  @Input() showLog:boolean;
  @Output() onUpload = new EventEmitter();
  control:FormControl;
  status:'success'|'failure'|'uploading' = 'uploading';
  subscription = new Subscription();
  constructor(
    private fileService:FileService,
    private cdRef:ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.control = new FormControl(this.file, fileUploadValidator);
    this.subscription.add(
      this.fileService.events.pipe(
        filter(e=>{
          return e.id === this.index;
        }),
        map(e=>e.event),
      ).subscribe(event=>{
        if (event.type === SbeUploadEventTypes.FileInfo) {
          this.status = 'success';
          this.cdRef.detectChanges();
        } else if (event.type === SbeUploadEventTypes.UploadError) {
          this.status = 'failure';
          this.cdRef.detectChanges();
        }
      })
    );
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }
  upload () {
    this.status = 'uploading';
    this.cdRef.detectChanges();
    return this.fileService.upload(this.file, this.options, this.access_token)
    .pipe(
      tap(event=>{
        this.fileService.events.next({id:this.options.upload_id, event, percent:this.fileService.turnEventToPercentage(event)});
      }),
    )
    .subscribe(event=>{
      if (event.type === SbeUploadEventTypes.FileInfo) {
        this.status = 'success';
        this.cdRef.detectChanges();
      } else if (event.type === SbeUploadEventTypes.UploadError) {
        this.status = 'failure';
        this.cdRef.detectChanges();
      }
    })
  }

  retry () {
    this.subscription.add(this.upload());
  }

}
